module.exports = __webpack_public_path__ + "ValvulaPlano3.png?df9d4cdf699added899ddd3e351975f2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ValvulaPlano3.png
// module id = 2887
// module chunks = 0